<div class="space-x-2">
  @if (showInfoButton()) {
    <i
      class="text-blue-600 hover:text-blue-800 cursor-pointer pi pi-info-circle"
      (click)="onEditClick($event)"
    ></i>
  }

  @if (hasPermissionDelete()) {
    <i
      class="pi pi-times cursor-pointer text-gray-600 hover:text-gray-800"
      (click)="onDeleteClick($event)"
    ></i>
  }
</div>
